<script lang="ts">
  import { _ } from 'svelte-i18n';
  import mbdParticipation from '../../assets/MBD-Teilnahmebedingungen_2024-09.pdf';
  import startingSoon from '../../assets/soon.jpg';

  let readMore = false;
  // let show_read_more = false;
  // set max height
  let max_content_height: number = 0;
  // get height of the content
  let content_height: number;

  $: show_read_more = readMore || content_height > max_content_height;

  const handleReadMore = () => {
    readMore = !readMore;
  };
</script>

<div
  class="flex max-h-[calc(100vh-72px-64px)] max-w-screen-lg flex-1 flex-col space-y-2 overflow-scroll sm:max-h-[calc(100vh-72px-64px)] sm:space-y-4"
>
  <div class="mx-auto flex flex-col">
    <div class="grid gap-2">
      <p class="title">
        {$_(
          'The campaign period of the cashback campaign 2023 has not yet started.',
        )}
      </p>
      <p class="font-sans-Bold text-sm font-semibold text-[#333]">
        {$_('The registration period starts soon.')}
      </p>
    </div>

    <div
      bind:clientHeight={max_content_height}
      id="parent"
      class="  {readMore ? 'overflow-y-visible' : 'overflow-y-hidden'}"
      style="height: ${content_height}px"
    >
      <div
        id="content"
        class=" max-w-screen-md pr-4 font-sans text-sm text-[#767676] md:text-justify"
      >
        <div bind:clientHeight={content_height} class="flex flex-col space-y-3">
          <!-- <p>
            {$_("Ladies and Gentlemen")}
          </p> -->
          <br />
          <p style="white-space: pre-line;">
            {$_(
              'starting on ... you can register here for the cashback action.',
            )}
          </p>

          <p>
            {$_('Further information can be found in the new terms.')}
            <!-- <a
              href={mbdParticipation}
              download
              class="cursor-pointer hover:text-primary-500"
              >
              {$_("Terms and Conditions")}
            </a> -->
          </p>

          <p>
            {$_('Thanks for your interest.')}
          </p>
        </div>
      </div>
    </div>

    <div class="max-w-screen-md py-2 sm:py-4">
      <img
        class="mx-auto object-cover"
        src={startingSoon}
        alt="Registration starting soon"
      />
    </div>
  </div>
</div>
